import {
  SHStack,
  SHTableCell,
  SHTableHead,
  SHTableRow,
  SHTypography,
} from "@components/design-systems";
import { PortfolioCompositionSetupDTO } from "@models/platform-analysis/entities/steps/summary";
import { memo } from "react";
import { SummaryPortfolioCompositionSetupLogo } from "../../rendered-items/setup-logo";

interface SummaryPortfolioCompositionTableHeadProps {
  setups?: PortfolioCompositionSetupDTO[];
  title?: string;
}

export const SummaryPortfolioCompositionTableHead = memo(
  ({
    setups,
    title = "Portfolio composition by platform",
  }: SummaryPortfolioCompositionTableHeadProps) => {
    return (
      <SHTableHead>
        <SHTableRow>
          <SHTableCell>
            <SHStack marginX={"10px"}>
              <SHTypography
                variant="subtitle1"
                sx={{
                  lineHeight: "150%",
                  fontWeight: 700,
                }}
              >
                {title}
              </SHTypography>
            </SHStack>
          </SHTableCell>

          {setups?.map((setup, index) => (
            <SHTableCell key={index}>
              <SummaryPortfolioCompositionSetupLogo setup={setup} />
            </SHTableCell>
          ))}
        </SHTableRow>
      </SHTableHead>
    );
  },
);
